module.exports = __webpack_public_path__ + "img/gift_1.3b035e5a.png";